module.exports = __webpack_public_path__ + "img/H-Forma180_ok.cb198ad2.png";